const signUpForm = $("#SetPasswordForm");
const numberOfRequiredUniqueChars = 6;
const passwordMinLength = 8;

$.validator.addMethod(
    "pwdRequiredUniqueChars",
    function (value, element) {
        if (!value || !value.length) {
            return false;
        }
        return checkPasswordUniqueChars(value);
    },
    "Passwords must use at least " + numberOfRequiredUniqueChars + " different characters"
);

$.validator.addMethod(
    "pwdCommonValidation",
    function (value, element) {
        let isSuccess = false;
        if (value && value.length >= passwordMinLength && checkPasswordUniqueChars(value)) {
            $.ajax({
                url: "/api/validation/common-password",
                type: "GET",
                data: { password: value },
                async: false,
                success: function (response) {
                    isSuccess = response;
                }
            });
        } else {
            isSuccess = true;
        }

        return isSuccess;
    },
    "The password you chose is too common"
);

signUpForm.validate({
    errorElement: "div",
    errorPlacement: function (error, element) {
        element.siblings("span.field-error").append(error);
    },
    highlight: function (element) {
        $(element).closest(".form-row").removeClass("has-error").addClass("has-error");
    },
    unhighlight: function (element) {
        $(element).closest(".form-row").removeClass("has-error");
    },
    rules: {
        "Password": {
            required: true,
            minlength: passwordMinLength,
            pwdRequiredUniqueChars: true,
            pwdCommonValidation: true
        },
        "ConfirmPassword": {
            required: true,
            equalTo: "#Password"
        }
    },
    messages: {
        "Password": {
            required: "Password is required",
            minlength: "Passwords must be at least 8 characters"
        },
        "ConfirmPassword": {
            required: "Confirm Password is required",
            equalTo: "Passwords do not match"
        }
    },
    onfocusout: function (element) {
        $(element).valid();
    },
    showErrors: function (errorMap, errorList) {
        this.defaultShowErrors();
        var summaryDiv = signUpForm.find("div.validation-summary"),
            container = summaryDiv.find("[data-valmsg-summary=true]"),
            list = container.find("ul");
        var errorElements = signUpForm.find(".error")
            .filter((index, element) => element.innerHTML);
        if (errorElements.length) {
            list.empty();
            container.addClass("validation-summary-errors").removeClass("validation-summary-valid");
            $.each(errorElements, function (index, element) {                
                $(element).css("display", "none");
                $("<li />").html(element.innerHTML).appendTo(list);
            });
            summaryDiv.show();
        } else {
            container.addClass("validation-summary-valid").removeClass("validation-summary-errors");
            summaryDiv.hide();
        }
    }
});

function checkPasswordUniqueChars(password) {
    return (String.prototype.concat(...new Set(password))).length >= numberOfRequiredUniqueChars;
}